export default function roundHalf(num) { 
    return (Math.round(num*2)/2).toFixed(1); 
}